import { render, staticRenderFns } from "./record2023.vue?vue&type=template&id=05d3bc55&scoped=true"
import script from "./record2023.vue?vue&type=script&lang=js"
export * from "./record2023.vue?vue&type=script&lang=js"
import style0 from "./record2023.vue?vue&type=style&index=0&id=05d3bc55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3bc55",
  null
  
)

export default component.exports